// angular
import { NgOptimizedImage } from '@angular/common';
import { Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
// services
import { StateManagementService } from '@app/+chat/shared/services/state-management.service';

@Component({
  selector: 'pwj-chat-header',
  standalone: true,
  imports: [NgOptimizedImage, TranslateModule],
  templateUrl: './chat-header.component.html',
  styleUrl: './chat-header.component.scss',
})
export class ChatHeaderComponent {
  // dependencies
  private readonly _stateManagementService = inject(StateManagementService);
  constructor() {}

  public toggleChatBox() {
    // close chat box
    this._stateManagementService.isChatBoxOpen.set(false);
  }
}
